var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1213"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1213"
    },
    "bundlingPackage": "hub-picker-ui",
    "bundlingPackageVersion": "static-1.13887",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};